import { render, staticRenderFns } from "./EmailHistory.vue?vue&type=template&id=096bc305&"
import script from "./EmailHistory.vue?vue&type=script&lang=ts&"
export * from "./EmailHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports